import React from 'react';
import PopoverMui from '../../../../../shared/PopoverMui/PopoverMui';
import {IconButtonMUI, ButtonMUI} from '../../../../../shared';
import {ReactComponent as NotificationsIcon} from '../../../../../assets/icons/chat-notifications.svg';
import {ReactComponent as AddUserIcon} from '../../../../../assets/icons/add-user.svg';
import {ReactComponent as BackIcon} from '../../../../../assets/icons/back.svg';
import {ReactComponent as Dots} from '../../../../../assets/icons/dots.svg';
import './ChatHero.scss';
import {useTranslation} from 'react-i18next';
import {useSelector} from "react-redux";
import {hasPermission} from "../../../../../helpers/functions";
import {PERMISSIONS} from "../../../../../helpers/constants";

const ChatHero = ({
                      title,
                      selectedBack,
                      handleClickAnchor,
                      handleClose,
                      openState,
                      anchorEl,
                      common,
                      companies,
                      commonName,
                      companiesName,
                      handleList,
                      handleUsers,
                      handleReadAll
                  }) => {
    const {t} = useTranslation();
    const profileMe = useSelector((state) => state.profile.profileMe);
    const hasPermissionMembers = hasPermission(PERMISSIONS.MEMBER_PROJECT_LIST, profileMe?.permissions ?? []);
    return (
        <div className='chat-hero'>
            <div className='chat-hero__info'>
                {selectedBack && (
                    <IconButtonMUI color='primary' onClick={handleList} title={t('all.back')}>
                        <BackIcon/>
                    </IconButtonMUI>
                )}

                <div className='chat-hero__title'>
                    {!selectedBack && <>{title}</>}
                    {common && <>{commonName}</>}
                    {companies && <>{companiesName}</>}
                </div>
            </div>

            <div className='chat-hero__actions'>
                <div className='chat-hero__actions-btn'>
                    <ButtonMUI size='small' onClick={handleReadAll}>
                        {t('ChatHero.readAll')}
                    </ButtonMUI>
                    {hasPermissionMembers ?
                        <IconButtonMUI onClick={handleUsers} title={t('ChatHero.participants')}>
                            <AddUserIcon/>
                        </IconButtonMUI> : null}
                </div>
            </div>

            <div className='chat-hero__dropdown'>
                <Dots onClick={handleClickAnchor}/>
                <PopoverMui
                    open={openState}
                    handleClose={() => {
                        handleClose();
                    }}
                    anchorEl={anchorEl}
                >
                    <div
                        className='chat-hero__link'
                        onClick={() => {
                            handleReadAll();
                            handleClose();
                        }}
                    >
                        <div className='chat-hero__circle'>
                            <NotificationsIcon/>
                        </div>
                        {t('ChatHero.readAll')}
                    </div>
                    <div className='chat-hero__link' onClick={handleUsers}>
                        <div className='chat-hero__circle'>
                            <AddUserIcon/>
                        </div>
                        {t('ChatHero.participants')}
                    </div>
                </PopoverMui>
            </div>
        </div>
    );
};

export default ChatHero;
